import axios from 'axios';
import {getCookie} from '@insticator/insticator-ui'; // iui-utils
import {url} from '../../../utils/urls';

const withCredentials = true;
const headers = {
  "Content-Type": "application/json",
  'Accept': 'application/json',
  'Authorization': `Bearer ${getCookie('pub_portal_user')}`
};

const imageHeaders = {
  'Content-Type': 'multipart/form-data'
};

export const fetchCommentingUnitCode = siteUUID => axios.get(`${url.ccu.base}/v1/sites/${siteUUID}/commenting-units/code`, { withCredentials });

export const fetchCommentingConfig = ({accountUUID, siteUUID, siteURL}) => axios.get(`${url.ccu.base}/v1/sites/${siteUUID}/configurations?accountUUID=${accountUUID}&siteURL=${siteURL}`, { withCredentials });

export const fetchCommentingRequestStatus = (accountUUID) => axios.get(`${url.ppa.url}/v1/accounts/${accountUUID}/product-access-requests?productType=COMMENTING_V2`, { withCredentials });

export const approveCommentingAccessRequest = (accountUUID) => axios.post(`${url.ppa.url}/v1/accounts/${accountUUID}/product-access-requests`, { 'productType': 'COMMENTING_V2' }, { withCredentials });

export const updateGeneral = ({commentingUnitConfigurationUUID, generalData}) => axios.put(`${url.ccu.base}/v1/commenting-units/configurations/${commentingUnitConfigurationUUID}/generals`, generalData, { headers, withCredentials });

export const updateAvatarPack = ({commentingUnitConfigurationUUID, avatarData}) => axios.put(`${url.ccu.base}/v1/commenting-units/configurations/${commentingUnitConfigurationUUID}/avatar-packs`, avatarData, { headers, withCredentials });

export const updateCommentsTree = ({commentTreeConfigurationUUID, commentsTreeData}) => axios.put(`${url.ccu.base}/v1/commenting-units/configurations/comments-tree/${commentTreeConfigurationUUID}`, commentsTreeData, { headers, withCredentials });

export const updateColorSchema = ({colorSchemaConfigurationUUID, colorSchemaData}) => axios.put(`${url.ccu.base}/v1/commenting-units/configurations/color-schemes/${colorSchemaConfigurationUUID}`, colorSchemaData, { headers, withCredentials });

export const updateCommunity = ({communityConfigurationUUID, communityData}) => axios.put(`${url.ccu.base}/v1/commenting-units/configurations/community/${communityConfigurationUUID}`, communityData, { headers, withCredentials });

export const uploadCommentingImage = (uploadImage) => axios.post(`${url.ccu.base}/v1/commenting-units/images`, uploadImage, { imageHeaders, withCredentials });

export const updateModeration = ({moderationConfigurationUUID, moderationData}) => axios.put(`${url.ccu.base}/v1/commenting-units/configurations/moderations/${moderationConfigurationUUID}`, moderationData, { headers, withCredentials });

export const fetchImportLists = (integrationId) => axios.get(`${url.itb.url}/import/${integrationId}/status`, { headers, withCredentials });

export const createNewImport = ({requestData}) => axios.post(`${url.itb.url}/import`, requestData , { headers, withCredentials });

export const importDisqusAPI = (requestData) => axios.post(`${url.itb.url}/import`, requestData , { headers, withCredentials });

export const cancelImport = ({integrationId, requestData}) => axios.put(`${url.itb.url}/import/${integrationId}/cancel`, requestData , { headers, withCredentials }); // integrationId is same as commentingUnitId

export const getTopThreadsExamples = ({integrationId, limit}) => axios.get(`${url.comment.adminAPI.administration}/getTopThreadsExamples?integrationId=${integrationId}&limit=${limit}`, { headers, withCredentials});

// commenting advanced
export const getMigrationStatus = commentingUnitUUID => axios.get(`${url.ccu.base}/pub-portal/v1/commenting-units/${commentingUnitUUID}/migrate-status`, { headers, withCredentials });

export const updateMigrationStatus = (commentingUnitUUID, status) => axios.put(`${url.ccu.base}/pub-portal/v1/commenting-units/${commentingUnitUUID}/migrate-status`, { status }, { headers, withCredentials });

export const getUpdatedCodes = (siteUUID) => axios.get(`${url.ccu.base}/v1/sites/${siteUUID}/commenting-units/add-ons/code?showOnlyNewCode=true`, { headers, withCredentials })

export const getExportData = (commentingUnitUUID, format) => axios.get(`${url.ccu.base}/v1/commenting-units/${commentingUnitUUID}/metrics/user-profiles/export?format=${format}`, { headers, withCredentials });

export const getAddOns = siteUUID => axios.get(`${url.ccu.base}/v1/sites/${siteUUID}/add-ons`, { headers, withCredentials });

export const createAddOnsSetting = ({type, request}) => axios.post(`${url.ccu.addOns}/${type}`, request, { headers, withCredentials });

export const updateAddOnsSetting = ({type, request, configurationUUID}) => axios.put(`${url.ccu.addOns}/${type}/${configurationUUID}`, request, { headers, withCredentials });

// Commenting Config 2.0
// TODO Move to separate api file
export const getTopArticlesExamples = ({ commentingUnitId, limit }) => axios.get(`${url.ccb.url}/v1/topArticlesExamples?commentingUnitId=${commentingUnitId}&limit=${limit}`, { withCredentials});

export const fetchCommentingConfigV2 = ({ siteUUID }) => axios.get(`${url.ccb.url}/v1/sites/${siteUUID}/commentingunits/configs?v2`, { withCredentials });

export const fetchCommentingV2DisplayConfig = ({ siteId }) => axios.get(`${url.ppa.url}/v1/configs/displayConfig?siteId=${siteId}&productType=COMMENTING_V2`, { withCredentials });

export const updateGeneralConfig = ({ commentingUnitId, data }) => axios.put(`${url.ccb.url}/v1/commentingunits/${commentingUnitId}/configs/general`, data, { headers, withCredentials });

export const updateAdminConfig = ({ commentingUnitId, data }) => axios.put(`${url.ccb.url}/v1/commentingunits/${commentingUnitId}/configs/admin`, data, { headers, withCredentials });

export const updateAdvancedConfig = ({ commentingUnitId, data }) => axios.put(`${url.ccb.url}/v1/commentingunits/${commentingUnitId}/configs/advanced`, data, { headers, withCredentials });

export const updateAdsConfig = ({ data }) => axios.post(`${url.ccb.url}/v1/sites/config/ads`, data, { headers, withCredentials });

export const updateDisplayConfig = ({ siteId, data }) => axios.put(`${url.ppa.url}/v1/configs/displayConfig?siteId=${siteId}&productType=COMMENTING_V2`, data, { headers, withCredentials });

export const updateDisplayConfigV2 = ({ commentingUnitId, data }) => axios.put(`${url.ccb.url}/v1/commentingunits/${commentingUnitId}/configs/site-themes`, data, { headers, withCredentials });

export const fetchEmojisCategories = () => axios.get(`${url.ppa.url}/v1/emojis/categories?filterV2=true`, { withCredentials });
